// src/routes/router.js
import React from "react";
import { createBrowserRouter, Outlet } from "react-router-dom";
import AppContent from "../auth/AppContent";
import PublicRoute from "./PublicRoute";
import PrivateRoute from "./PrivateRoute";

import Home from "../pages/Home";
import RecordedContact from "../pages/RecordedContact/RecordedContact";
import ThirdPartyContact from "../pages/ThirdPartyContact/ThirdPartyContact";
import User from "../pages/Users/Users";
import RecordedCall from "../pages/RecordedCall/RecordedCall";
import Playlists from "../pages/Playlist/Playlists";
import PlaylistsCalls from "../pages/Playlist/PlaylistCalls";
import RecordedContactInsights from "../pages/RecordedContactInsights/RecordedContactInsights";
import MyAccount from "../pages/MyAccount";
import Settings from "../pages/Settings";
import Reports from "../pages/Report/Reports";

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <AppContent>
        <Outlet />
      </AppContent>
    ),
    children: [
      // PUBLIC only for ROOT
      { index: true, element: <PublicRoute /> },

      // PRIVATE ROUTES — MUST BE RELATIVE (no leading "/")
      { path: "home", element: <PrivateRoute><Home /></PrivateRoute> },
      { path: "recorded-contacts", element: <PrivateRoute><RecordedContact /></PrivateRoute> },
      { path: "third-party-contacts", element: <PrivateRoute><ThirdPartyContact /></PrivateRoute> },
      { path: "users", element: <PrivateRoute><User /></PrivateRoute> },
      { path: "recorded-calls", element: <PrivateRoute><RecordedCall /></PrivateRoute> },
      { path: "playlists", element: <PrivateRoute><Playlists /></PrivateRoute> },
      { path: "playlists/:playlistId", element: <PrivateRoute><PlaylistsCalls /></PrivateRoute> },
      { path: "insights/recorded-contacts", element: <PrivateRoute><RecordedContactInsights /></PrivateRoute> },
      { path: "insights/reports", element: <PrivateRoute><Reports /></PrivateRoute> },
      { path: "my-account", element: <PrivateRoute><MyAccount /></PrivateRoute> },
      { path: "settings", element: <PrivateRoute><Settings /></PrivateRoute> },

      { path: "*", element: <div>Route Not Found</div> },
    ],
  },
]);

export default router;
